import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import LeaveGroup from 'modules/posts/components/Groups/Leave'

const LeaveGroupPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const location = useLocation()

  const getBackPath = () => {
    if (location.pathname.includes(navigation.dashboard.fullPath())) {
      return navigation.dashboard.fullPath()
    }
    return navigation.communities.id.fullPath({ id: id ?? '0' })
  }

  return <LeaveGroup onClose={() => navigate(getBackPath())} groupId={id ?? ''} />
}

export default LeaveGroupPage
